/* eslint no-shadow:0 */
import axios from 'axios';

const data = {
  qoute: {},
  quoteRequestValues: {},
  computedQuoteValues: {},
};
const getters = {
  getQoute: (state) => state.qoute,
  getQuoteRequestValues: (state) => state.quoteRequestValues,
  getComputedQuoteValues: (state) => state.computedQuoteValues,
};

const mutations = {
  setQuotation(state, data) {
    state.qoute = data;
  },
  setQuoteRequestValues(state, data) {
    state.quoteRequestValues = data;
  },
  setComputedQuoteValues(state, data) {
    state.computedQuoteValues = data;
  },
};
const actions = {
  getQuotation: async (context, id) => {
    await axios.get(`/customer/quotation?quoteId=${id}`).then((response) => {
      context.commit('setQuotation', response.data.data);
    });
  },
};

export default {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};
